import React from 'react';

interface ScoreAppHeaderProps {
  // Left side content
  leftContent?: React.ReactNode;
  
  // Center content (tabs)
  centerContent?: React.ReactNode;
  
  // Right side content (primary button)
  rightContent?: React.ReactNode;
  
  // Background styling
  backgroundColor?: 'white' | 'transparent';
  className?: string;
  
  // Sticky positioning
  sticky?: boolean;
  
  // Mobile props
  isMobile?: boolean;
  onToggleSidebar?: () => void;
}

const ScoreAppHeader: React.FC<ScoreAppHeaderProps> = ({
  leftContent,
  centerContent,
  rightContent,
  backgroundColor = 'white',
  className = '',
  sticky = false,
  isMobile = false,
  onToggleSidebar
}) => {
  const bgClass = backgroundColor === 'white' ? 'bg-white' : 'bg-transparent';
  const stickyClass = sticky ? 'sticky top-0 z-50' : '';
  
  return (
    <div className={`${bgClass} border-b border-gray-200 px-3 sm:px-6 py-3 sm:py-4 ${stickyClass} ${className}`}>
      <div className="flex items-center justify-between">
        {/* Left Content - Mobile Menu Button + Original Content */}
        <div className="flex items-center space-x-2 sm:space-x-4">
          {/* Mobile Menu Button */}
          {isMobile && onToggleSidebar && (
            <button
              onClick={onToggleSidebar}
              className="p-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 min-h-44 min-w-44"
              title="Open menu"
              aria-label="Open menu"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          )}
          {leftContent}
        </div>
        
        {/* Center Content */}
        <div className="flex-1 flex justify-center">
          {centerContent}
        </div>
        
        {/* Right Content - Hidden on Mobile */}
        {!isMobile && (
          <div className="flex items-center">
            {rightContent}
          </div>
        )}
      </div>
    </div>
  );
};

export default ScoreAppHeader;
